import React from "react";
import sidebarStyles from "styles/sidebar.module.scss";
import pageStyles from "styles/page.module.scss";
import Logo from "svgs/logo_v2.png";

// Dependency-free loading placeholder. Two modes:
//  - default: full app shell (sidebar + content shimmer), used at the
//    Authenticator boot gate BEFORE the real sidebar exists.
//  - contentOnly: just the content-pane shimmer, used as the <Suspense>
//    fallback for lazily-loaded routes (the real <Sidebar> is already
//    rendered alongside, so the fallback must NOT include its own sidebar).
// Purely presentational: no context, hooks, or router — it can never crash.
const NAV_LABELS = [
  "Getting started",
  "Dashboard",
  "Cart Setup",
  "Upsell Campaigns",
  "Sticky cart",
  "Integrations",
  "Your Plan",
  "Faq"
];

// Shimmer placeholder block. Gradient sweep animated via the keyframes below.
const shimmer = (width, height, extra = {}) => ({
  width,
  height,
  borderRadius: 8,
  background:
    "linear-gradient(90deg, #e7eaf0 25%, #f1f3f7 37%, #e7eaf0 63%)",
  backgroundSize: "400% 100%",
  animation: "muShimmer 1.4s ease infinite",
  ...extra
});

const Keyframes = () => (
  <style>{`@keyframes muShimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}`}</style>
);

const ContentShimmer = () => (
  <div className={pageStyles.app_container}>
    <div className={pageStyles.topBarWrapper} />
    <div className={pageStyles.page}>
      <div className={pageStyles.page_content}>
        {/* page title / subtitle placeholders */}
        <div style={shimmer("240px", 22)} />
        <div style={shimmer("160px", 14, { marginTop: 12 })} />
        {/* content card placeholders */}
        <div style={{ marginTop: 28, display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={shimmer("100%", 132, { borderRadius: 12 })} />
          <div style={shimmer("100%", 132, { borderRadius: 12 })} />
          <div style={shimmer("100%", 132, { borderRadius: 12 })} />
        </div>
      </div>
    </div>
  </div>
);

export default function AppShellSkeleton({ contentOnly = false }) {
  if (contentOnly) {
    return (
      <React.Fragment>
        <Keyframes />
        <ContentShimmer />
      </React.Fragment>
    );
  }
  return (
    <div className={pageStyles.app_wrapper} aria-busy="true" aria-label="Loading">
      <Keyframes />
      <div className={sidebarStyles.sidebar}>
        <div className={sidebarStyles.logo}>
          <img src={Logo} alt="Monster Upsell" />
        </div>
        <div className={sidebarStyles.menu}>
          {NAV_LABELS.map((label) => (
            <div key={label} className={sidebarStyles.menu_item}>
              <div>
                <span className={sidebarStyles.text}>{label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ContentShimmer />
    </div>
  );
}
